import { trackingPatterns } from "@/lib/constants";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export function validateTrackingType(trackingCode: string) {
  if (trackingPatterns.correios.test(trackingCode)) {
    return "correios";
  }
  if (trackingPatterns.melhorEnvio.test(trackingCode)) {
    return "melhorenvio";
  }
  if (trackingPatterns.jadlog.test(trackingCode)) {
    return "jadlog";
  }
  if (trackingPatterns.beuni.test(trackingCode)) {
    return "beuni";
  }

  return "melhorenvio";
}

// Data falada, como nos apps de entrega: "hoje", "ontem" ou "18 de out.".
export function diaFalado(inputDate: string) {
  const date = new Date(inputDate);
  const hoje = new Date();
  const ontem = new Date();
  ontem.setDate(hoje.getDate() - 1);
  const mesmoDia = (a: Date, b: Date) => a.toDateString() === b.toDateString();
  if (mesmoDia(date, hoje)) return "hoje";
  if (mesmoDia(date, ontem)) return "ontem";
  return format(date, date.getFullYear() === hoje.getFullYear() ? "d 'de' MMM" : "d 'de' MMM 'de' yyyy", { locale: ptBR });
}

export function hora(inputDate: string) {
  return format(new Date(inputDate), "HH:mm");
}

// "hoje, 11:22" · "18 de out., 14:02"
export function quando(inputDate: string) {
  return `${diaFalado(inputDate)}, ${hora(inputDate)}`;
}
